import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapIotCallingToDataTable as mapData } from "./Helper";
import GetIotCallingColumn from "./ColumnDefinition/IotCallingColumn/GetIotCallingColumn";

const IotCallingTable = ({ data, handleDelete, handleOpenPopup, status }) => {
  const columns = GetIotCallingColumn({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default IotCallingTable;
